//Styles
import './styles/terms.css'

//Extras
import { fontType, main } from '../assets/extras'

import { useEffect, useState } from "react"

const Terms = () => {

    const termsList = [{
        index: 0,
        title: "Tepeyac"
    }, {
        index: 1,
        title: "Lindavista"
    }]

    const [selectedTerms, setSelectedTemrs] = useState(termsList[0].index)

    useEffect(() => {
        document.title = "Terminos y condiciones"
    }, [])

    /**
     * FUNCIONES PARA LOS TERMINOS DE CADA CENTRO
     */
    const container = {
        fontFamily: '"Segoe UI", Arial, sans-serif',
        lineHeight: 1.6,
        color: "#333",
        backgroundColor: "#fff",
        padding: "40px",
        maxWidth: "800px",
        margin: "auto",
    };

    const h1 = {
        textAlign: "center",
        textTransform: "uppercase",
        fontSize: "24px",
        color: "#222",
        marginTop: "30px",
    };

    const h2 = {
        textAlign: "center",
        fontSize: "20px",
        marginTop: "40px",
        borderBottom: "2px solid #ddd",
        paddingBottom: "6px",
        color: "#222",
    };

    const h3 = {
        marginTop: "30px",
        color: "#222",
    };

    const section = {
        marginBottom: "40px",
    };

    const list = {
        marginLeft: "30px",
    };

    const listItem = {
        marginBottom: "8px",
    };

    const paragraph = {
        margin: "12px 0",
    };

    const firma = {
        marginTop: "50px",
        textAlign: "center",
        fontWeight: "bold",
    };

    const TepeyactTerms = () => {
        return (
            <div style={container}>
                <h1 style={h1}>Academia Tenista Tepeyac</h1>
                <h2 style={h2}>TÉRMINOS Y CONDICIONES GENERALES DEL SERVICIO</h2>

                <div style={section}>
                    <h3 style={h3}>INSCRIPCIÓN $1,000.00 con derecho a:</h3>
                    <ol style={list}>
                        <li style={listItem}>Mantener un horario de clases de tenis durante un año.</li>
                        <li style={listItem}>
                            Al inscribirse se le agregará a un chat de información de la Academia al que se le pide no salir ya que solo es para información eventual.
                        </li>
                    </ol>
                </div>

                <div style={section}>
                    <h3 style={h3}>REQUISITOS</h3>
                    <ul style={list}>
                        <li style={listItem}>Tomar clase muestra de acuerdo a los horarios disponibles de acuerdo al nivel y que más le acomoden.</li>
                        <li style={listItem}>Llenar el formulario de inscripción desde su cel en los siguientes links.</li>
                        <li style={listItem}>Realiza el pago de la inscripción.</li>
                        <li style={listItem}>Realizar el pago de la mensualidad.</li>
                        <li style={listItem}>
                            Traer su propio equipo. (tenis para tenis y raqueta si le llegara a faltar aquí le podemos prestar una raqueta provisional).
                        </li>
                        <li style={listItem}>Agua, ropa deportiva y bloqueador.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>PRECIOS Y PAGOS</h3>
                    <ul style={list}>
                        <li style={listItem}>
                            El precio de las clases grupales es de $1,500 (4 horas a la semana / 16 hrs al mes), $2,000 (6 horas a la semana / 24 horas al mes) y $2,500 (8 horas a la semana / 32 horas al mes).
                        </li>
                        <li style={listItem}>
                            La mensualidad se deberá pagar durante el tiempo en que esté inscrito el alumno y SIN INTERRUPCIONES o EXCEPCIONES, durante los primeros 10 días de cada mes de lo contrario se cobrará una cuota de $100 pesos por pago tardío si paga después del día 15.
                        </li>
                        <li style={listItem}>
                            El alumno podrá reponer las clases que no haya tomado por alguna causa justificable (fuerza mayor) siempre y cuando se comunique con los profesores de la clase para agendar la reposición y haya espacio disponible.
                        </li>
                        <li style={listItem}>Si el alumno o usuario no pagará la mensualidad o anualidad el alumno se estará dando de baja automáticamente.</li>
                        <li style={listItem}>
                            Si por alguna razón el alumno no pudiera tomar las clases durante todo un mes por alguna causa de fuerza mayor, podrá reponerlas siempre y cuando haya realizado el pago mínimo de $500 para mantener su lugar.
                        </li>
                        <li style={listItem}>
                            La Academia tomará como vacaciones la última y la primera semana del año, los días santos y una semana posterior al Curso de Verano, pero eso no implicará el no pagar su mensualidad o clases particulares, ya que las podrán reponer antes de vacaciones o una vez reiniciada la actividad.
                        </li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>OTRAS CONSIDERACIONES</h3>
                    <ul style={list}>
                        <li style={listItem}>La Academia repondrá las clases que por alguna causa no haya podido impartir.</li>
                        <li style={listItem}>
                            En caso de lluvia o contingencia u otros factores externos:
                            <ul style={list}>
                                <li style={listItem}>
                                    A) Se INTENTARÁ reponer la hora de clase en diferentes horarios de su misma edad o categoría.
                                </li>
                            </ul>
                        </li>
                        <li style={listItem}>
                            En caso de tardanzas:
                            <ul style={list}>
                                <li style={listItem}>A) Si el Profesor llegara tarde, antes de los 20 minutos tendrá que reponer el tiempo perdido.</li>
                                <li style={listItem}>B) Si el alumno llegara tarde, antes de los 20 minutos podrá tomar su clase.</li>
                                <li style={listItem}>C) Si el Profesor llegara tarde, después de los 20 minutos tendrá que reponer la clase completa.</li>
                                <li style={listItem}>D) Si el alumno llegara tarde, después de los 20 minutos ya no podrá tomar su clase.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h2 style={h2}>CLASES PARTICULARES</h2>

                <div style={section}>
                    <h3 style={h3}>INSCRIPCIÓN $1,000.00 con derecho a:</h3>
                    <ol style={list}>
                        <li style={listItem}>Mantener un horario de clases de tenis durante un año.</li>
                        <li style={listItem}>
                            Al inscribirse se le agregará a un chat de información del Centro de Tenis al que se le pide no salir ya que solo es para información eventual.
                        </li>
                    </ol>
                </div>

                <div style={section}>
                    <h3 style={h3}>REQUISITOS</h3>
                    <ul style={list}>
                        <li style={listItem}>Tomar clase muestra grupal de acuerdo a los horarios que más le acomoden.</li>
                        <li style={listItem}>Llenar el formato de inscripción.</li>
                        <li style={listItem}>Realiza el pago de la inscripción.</li>
                        <li style={listItem}>Realizar el pago de la mensualidad.</li>
                        <li style={listItem}>
                            Traer su propio equipo. (si le llegara a faltar aquí le podemos prestar una raqueta provisional).
                        </li>
                        <li style={listItem}>Agua, ropa deportiva y bloqueador.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>PRECIOS Y PAGOS</h3>
                    <ul style={list}>
                        <li style={listItem}>El precio de las clases particulares es de $380 si no está inscrito o son clases esporádicas.</li>
                        <li style={listItem}>El precio de las clases particulares es de $330 si está inscrito y tiene reservado un horario fijo.</li>
                        <li style={listItem}>Si el alumno desea agendar sus clases particulares con horario y profesor fijo deberá pagar de forma mensual.</li>
                        <li style={listItem}>
                            Si el alumno desea mantener su horario pero avisa que no podrá asistir a todas las clases con anticipación de 1 mes, deberá pagar la mitad de la clase para mantener su horario, al menos que se consiga a un sustituto.
                        </li>
                        <li style={listItem}>
                            La mensualidad se deberá pagar durante el tiempo en que esté inscrito el alumno y SIN INTERRUPCIONES o EXCEPCIONES, durante los primeros 10 días de cada mes de lo contrario se cobrará una cuota de $100 pesos por pago tardío, después del día 15.
                        </li>
                        <li style={listItem}>El alumno podrá reponer las clases que no haya tomado siempre y cuando se comunique con la recepción para agendar la reposición.</li>
                        <li style={listItem}>Si no se pagara la mensualidad el alumno se estará dando de baja automáticamente.</li>
                        <li style={listItem}>Si el alumno faltara durante el mes por enfermedad o lesión, deberá pagar la mitad de la clase para mantener su horario.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>OTRAS CONSIDERACIONES</h3>
                    <ul style={list}>
                        <li style={listItem}>La Academia repondrá las clases que por alguna causa no haya podido impartir.</li>
                        <li style={listItem}>Las clases que no se hayan podido reponer y ya fueron pagadas se descontarán en la siguiente mensualidad.</li>
                        <li style={listItem}>
                            En caso de tardanzas:
                            <ul style={list}>
                                <li style={listItem}>A) Si el Profesor llegara tarde, antes de los 20 minutos tendrá que reponer el tiempo perdido.</li>
                                <li style={listItem}>B) Si el alumno llegara tarde, antes de los 20 minutos podrá tomar su clase.</li>
                                <li style={listItem}>C) Si el Profesor llegara tarde, después de los 20 minutos tendrá que reponer la clase completa.</li>
                                <li style={listItem}>D) Si el alumno llegara tarde, después de los 20 minutos ya no podrá tomar su clase.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>DECLARACIÓN</h3>
                    <p style={paragraph}>El que suscribe, declara bajo protesta de decir verdad:</p>
                    <ul style={list}>
                        <li style={listItem}>A) Que me represento a mí mismo como mayor de edad o soy Padre o tutor del menor de edad cuyos datos aparecen en la presente hoja de inscripción.</li>
                        <li style={listItem}>B) Que tengo plena capacidad para otorgar el presente permiso con todos sus alcances legales y no tengo limitación alguna como padre o tutor.</li>
                        <li style={listItem}>C) Que conozco las actividades y reconozco que hay riesgos asociados con la participación en las actividades de los cursos y/o eventos.</li>
                        <li style={listItem}>D) Que yo o el menor al que represento no tiene limitación física alguna o de cualquier otra índole para la realización del presente curso, salvo las expresadas en la presente hoja de inscripción.</li>
                        <li style={listItem}>
                            E) Que estoy de acuerdo en asumir todos los riesgos y responsabilidades que mi hijo/hija/menor pudiera tener a consecuencia de la participación en los cursos y/o torneos, por lo que libero a Academia Tenista, a los directores de los cursos/torneos, a sus instructores, colaboradores y al personal en general de la Academia Tenista, de cualquier responsabilidad, incluyendo de manera enunciativa pero no limitativa por negligencias y/o lesiones. Por la presente autorizo al profesor encargado de administrar la clase para proporcionar al hijo/hija/menor el tratamiento de emergencia de primeros auxilios que éste requiera, en el caso de un accidente y tomar decisiones sobre la salud del menor en caso de ser necesario y no se encontrare por teléfono al familiar y no estuviera presente.
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    const LindavistaTerms = () => {
        return (
            <div style={container}>
                <h1 style={h1}>Academia Tenista Lindavista</h1>
                <h2 style={h2}>TÉRMINOS Y CONDICIONES GENERALES DEL SERVICIO</h2>

                <div style={section}>
                    <h3 style={h3}>INSCRIPCIÓN $1,000.00 con derecho a:</h3>
                    <ol style={list}>
                        <li style={listItem}>Mantener un horario de clases de tenis durante un año.</li>
                        <li style={listItem}>
                            Al inscribirse se le agregará a un chat de información del Centro de Tenis al que se le pide no salir ya que solo es para información eventual.
                        </li>
                    </ol>
                </div>

                <div style={section}>
                    <h3 style={h3}>REQUISITOS</h3>
                    <ul style={list}>
                        <li style={listItem}>Tomar clase muestra de acuerdo a los horarios disponibles de acuerdo al nivel y que más le acomoden.</li>
                        <li style={listItem}>Llenar el formulario de inscripción desde su teléfono en los siguientes links.</li>
                        <li style={listItem}>Realiza el pago de la inscripción.</li>
                        <li style={listItem}>Realizar el pago de la mensualidad.</li>
                        <li style={listItem}>
                            Traer su propio equipo. (tenis para tenis y raqueta si le llegara a faltar aquí le podemos prestar una raqueta provisional)
                        </li>
                        <li style={listItem}>Agua, ropa deportiva y bloqueador.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>PRECIOS Y PAGOS</h3>
                    <ul style={list}>
                        <li style={listItem}>
                            El precio de las clases grupales es de $1,300 (4 horas a la semana / 16 hrs al mes), $1,800 (6 horas a la semana / 24 horas al mes) y $2,300 (8 horas a la semana / 32 horas al mes).
                        </li>
                        <li style={listItem}>En dado caso que solo pudiera 2 hrs por semana, el precio es de $1,000 al mes.</li>
                        <li style={listItem}>
                            La mensualidad se deberá pagar durante el tiempo en que esté inscrito el alumno y SIN INTERRUPCIONES o EXCEPCIONES, durante los primeros 10 días de cada mes de lo contrario se cobrará una cuota de $100 pesos por pago tardío si paga después del día 15.
                        </li>
                        <li style={listItem}>
                            El alumno podrá reponer las clases que no haya tomado por alguna causa justificable (fuerza mayor) siempre y cuando se comunique con los profesores de la clase para agendar la reposición y haya espacio disponible.
                        </li>
                        <li style={listItem}>Si el alumno o usuario no pagará la mensualidad o anualidad el alumno se estará dando de baja automáticamente.</li>
                        <li style={listItem}>
                            Si por alguna razón el alumno no pudiera tomar las clases durante todo un mes por alguna causa de fuerza mayor, podrá reponerlas siempre y cuando haya realizado el pago mínimo de $500 para mantener su lugar.
                        </li>
                        <li style={listItem}>
                            La Academia tomará como vacaciones la última y la primera semana del año, los días santos y una semana posterior al Curso de Verano, pero eso no implicará el no pagar su mensualidad o clases particulares, ya que las podrán reponer antes de vacaciones o una vez reiniciada la actividad.
                        </li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>OTRAS CONSIDERACIONES</h3>
                    <ul style={list}>
                        <li style={listItem}>La Academia repondrá las clases que por alguna causa no haya podido impartir.</li>
                        <li style={listItem}>
                            En caso de lluvia o contingencia u otros factores externos:
                            <ul style={list}>
                                <li style={listItem}>A) Se INTENTARÁ reponer la hora de clase en diferentes horarios de su misma edad o categoría.</li>
                            </ul>
                        </li>
                        <li style={listItem}>
                            En caso de tardanzas:
                            <ul style={list}>
                                <li style={listItem}>A) Si el Profesor llegara tarde, antes de los 20 minutos tendrá que reponer el tiempo perdido.</li>
                                <li style={listItem}>B) Si el alumno llegara tarde, antes de los 20 minutos podrá tomar su clase.</li>
                                <li style={listItem}>C) Si el Profesor llegara tarde, después de los 20 minutos tendrá que reponer la clase completa.</li>
                                <li style={listItem}>D) Si el alumno llegara tarde, después de los 20 minutos ya no podrá tomar su clase.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h2 style={h2}>CLASES PARTICULARES</h2>

                <div style={section}>
                    <h3 style={h3}>INSCRIPCIÓN $1,000.00 con derecho a:</h3>
                    <ol style={list}>
                        <li style={listItem}>Mantener un horario de clases de tenis durante un año.</li>
                        <li style={listItem}>
                            Al inscribirse se le agregará a un chat de información del Centro de Tenis al que se le pide no salir ya que solo es para información eventual.
                        </li>
                    </ol>
                </div>

                <div style={section}>
                    <h3 style={h3}>REQUISITOS</h3>
                    <ul style={list}>
                        <li style={listItem}>Tomar clase muestra grupal de acuerdo a los horarios que más le acomoden.</li>
                        <li style={listItem}>Llenar el formato de inscripción.</li>
                        <li style={listItem}>Realiza el pago de la inscripción.</li>
                        <li style={listItem}>Realizar el pago de la mensualidad.</li>
                        <li style={listItem}>
                            Traer su propio equipo. (si le llegara a faltar aquí le podemos prestar una raqueta provisional)
                        </li>
                        <li style={listItem}>Agua, ropa deportiva y bloqueador.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>PRECIOS Y PAGOS</h3>
                    <ul style={list}>
                        <li style={listItem}>El precio de las clases particulares es de $300 si no está inscrito o son clases esporádicas.</li>
                        <li style={listItem}>El precio de las clases particulares es de $350 si está inscrito y tiene reservado un horario fijo.</li>
                        <li style={listItem}>Si el alumno desea agendar sus clases particulares con horario y profesor fijo deberá pagar de forma mensual.</li>
                        <li style={listItem}>
                            Si el alumno desea mantener su horario pero avisa que no podrá asistir a todas las clases con anticipación de 1 mes, deberá pagar la mitad de la clase para mantener su horario, al menos que se consiga a un sustituto.
                        </li>
                        <li style={listItem}>
                            La mensualidad se deberá pagar durante el tiempo en que esté inscrito el alumno y SIN INTERRUPCIONES o EXCEPCIONES, durante los primeros 10 días de cada mes de lo contrario se cobrará una cuota de $100 pesos por pago tardío, después del día 15.
                        </li>
                        <li style={listItem}>El alumno podrá reponer las clases que no haya tomado siempre y cuando se comunique con la recepción para agendar la reposición.</li>
                        <li style={listItem}>Si no se pagara la mensualidad el alumno se estará dando de baja automáticamente.</li>
                        <li style={listItem}>Si el alumno faltara durante el mes por enfermedad o lesión, deberá pagar la mitad de la clase para mantener su horario.</li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>OTRAS CONSIDERACIONES</h3>
                    <ul style={list}>
                        <li style={listItem}>La Academia repondrá las clases que por alguna causa no haya podido impartir.</li>
                        <li style={listItem}>Las clases que no se hayan podido reponer y ya fueron pagadas se descontarán en la siguiente mensualidad.</li>
                        <li style={listItem}>
                            En caso de tardanzas:
                            <ul style={list}>
                                <li style={listItem}>A) Si el Profesor llegara tarde, antes de los 20 minutos tendrá que reponer el tiempo perdido.</li>
                                <li style={listItem}>B) Si el alumno llegara tarde, antes de los 20 minutos podrá tomar su clase.</li>
                                <li style={listItem}>C) Si el Profesor llegara tarde, después de los 20 minutos tendrá que reponer la clase completa.</li>
                                <li style={listItem}>D) Si el alumno llegara tarde, después de los 20 minutos ya no podrá tomar su clase.</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div style={section}>
                    <h3 style={h3}>DECLARACIÓN</h3>
                    <p style={paragraph}>El que suscribe, declara bajo protesta de decir verdad:</p>
                    <ul style={list}>
                        <li style={listItem}>A) Que me represento a mí mismo como mayor de edad o soy Padre o tutor del menor de edad cuyos datos aparecen en la presente hoja de inscripción.</li>
                        <li style={listItem}>B) Que tengo plena capacidad para otorgar el presente permiso con todos sus alcances legales y no tengo limitación alguna como padre o tutor.</li>
                        <li style={listItem}>C) Que conozco las actividades y reconozco que hay riesgos asociados con la participación en las actividades de los cursos y/o eventos.</li>
                        <li style={listItem}>D) Que yo o el menor al que represento no tiene limitación física alguna o de cualquier otra índole para la realización del presente curso, salvo las expresadas en la presente hoja de inscripción.</li>
                        <li style={listItem}>
                            E) Que estoy de acuerdo en asumir todos los riesgos y responsabilidades que mi hijo/hija/menor pudiera tener a consecuencia de la participación en los cursos y/o torneos, por lo que libero a Academia Tenista, a los directores de los cursos/torneos, a sus instructores, colaboradores y al personal en general de la Academia Tenista, de cualquier responsabilidad, incluyendo de manera enunciativa pero no limitativa por negligencias y/o lesiones. Por la presente autorizo al profesor encargado de administrar la clase para proporcionar al hijo/hija/menor el tratamiento de emergencia de primeros auxilios que éste requiera, en el caso de un accidente y tomar decisiones sobre la salud del menor en caso de ser necesario y no se encontrare por teléfono al familiar y no estuviera presente.
                        </li>
                    </ul>
                </div>
            </div>
        )
        /**
         * <div style={firma}>
                    FECHA _______________________ &nbsp;&nbsp;&nbsp;&nbsp; ACEPTO _______________________
                </div>
         */
    }

    const whichTerms = () => {
        const termsArray = [
            <TepeyactTerms />,
            <LindavistaTerms />
        ]

        return termsArray[selectedTerms]
    }

    return (
        <div className="contTerms">

            <nav style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: main,
                width: "100vw",
                height: 80,
                display: "flex ",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                gap: 20
            }}>
                {
                    termsList.map((v, i) => {
                        return (
                            <div style={{
                                border: "2px solid white",
                                width: 150,
                                height: 50,
                                borderRadius: 10,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: selectedTerms == v.index && "white",
                            }} onClick={() => {
                                //Cambiamos la seleccion de los terminos
                                setSelectedTemrs(prev => (v.index))
                            }}>
                                <p style={{
                                    textAlign: "center",
                                    color: selectedTerms == v.index ? "black" : "white",
                                    fontFamily: fontType.title,
                                    fontSize: 18,
                                    cursor: "pointer"
                                }}>{v.title}</p>
                            </div>
                        )
                    })
                }
            </nav>

            {
                whichTerms()
            }

        </div>
    )
}

export default Terms